import OverlaySpinner from './OverlaySpinner';

export default OverlaySpinner;
